import { render, staticRenderFns } from "./ActionsMenu.vue?vue&type=template&id=6c0c49b4&"
import script from "./ActionsMenu.vue?vue&type=script&lang=js&"
export * from "./ActionsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c0c49b4')) {
      api.createRecord('6c0c49b4', component.options)
    } else {
      api.reload('6c0c49b4', component.options)
    }
    module.hot.accept("./ActionsMenu.vue?vue&type=template&id=6c0c49b4&", function () {
      api.rerender('6c0c49b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/configurationManager/ActionsMenu.vue"
export default component.exports